import store from '../store'
import router from '../router'
import qs from 'qs'
import { Dialog } from 'vant';

// base64编码
export const Base64 = {
    encode(str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
    },
    decode(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
};

//文件转base64
export function fileToImgFn(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file); // 读出 base64
        let dataURL
        reader.onloadend = () => {
            // 图片的 base64 格式, 可以直接当成 img 的 src 属性值        
            dataURL = reader.result;
            resolve(dataURL)
        };
    })
}

//千分补空
export function get_thousand_num_null(num) {
    if (!Boolean(num)) {
        return 0
    }
    return num.toString().replace(/\d+/, function(n) { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) { // 对整数部分添加分隔符
            return $1 + ' '
        })
    })
}

//倒计时
export function tiemBack(obj) {
    // obj = {
    //   timer:"",  //倒计时文字
    //   timeId:''  //定时
    // }
    let time = 60;
    obj.timer = time + "s";
    obj.timeId = setInterval(() => {
        time--
        if (time > 0) {
            obj.timer = time + "s"
            return;
        }
        clearInterval(obj.timeId);
        obj.timer = "获取验证码";
    }, 999);
}

//发送短信
export function sendSms(obj) {
    return new Promise((resolve, reject) => {
        this.$http
            .post("/verify/sendCode", obj)
            .then(({ data }) => {
                if (data.code == 0) {
                    this.$toast("验证码已发送")
                    resolve(true)
                    return
                }
                this.$toast(data.msg)
                resolve(false)
            })
            .catch(err => {
                this.$toast("短信发送失败");
                resolve(false);
            });
    });
}

// 退出
export function loguot() {
    return new Promise((resolve, reject) => {
        this.$http.post(`/user/logout`).then(({ data }) => {
            this.$toast("已经退出");
            resolve(data);
        }).catch((err) => {
            this.$toast("退出失败");
            resolve(false);
        });
    })
}
export function userInfo() {
    this.$http.post(`/equipment/queryCardInfo`, { card: this.$store.state.user.iccid }).then(({ data }) => {
        this.$store.commit("Login", {
            appId: data.data.AppID,
            userMoney: data.data.userMoney,
            mobile: data.data.mobile
        })
    }).catch((err) => {});
}




export function draw(percent, days = 0, flow = 0, sR = Math.PI / 1.3) {
    if (percent < 0 || percent > 100) {
        return;
    }
    if (sR < Math.PI / 2 || sR >= 3 / 2 * Math.PI) {
        return;
    }

    var canvas = document.querySelector('#sectorFlow'),
        cxt = canvas.getContext('2d'),
        cWidth = canvas.width,
        cHeight = canvas.height,
        baseColor = '#e1e1e1',
        coverColor = '#1df77e',
        textColor = '#fff',
        PI = Math.PI,
        sR = sR || 1 / 2 * PI; // 默认圆弧的起始点弧度为π/2

    var finalRadian = sR + ((PI + (PI - sR) * 2) * percent / 100); // 红圈的终点弧度
    var step = (PI + (PI - sR) * 2) / 100; // 一个1%对应的弧度大小
    var text = 0; // 显示的数字

    window.requestAnimationFrame(paint);

    function paint() {
        cxt.clearRect(0, 0, cWidth, cHeight);
        var endRadian = sR + text * step;
        // 画灰色圆弧
        drawCanvas(cWidth / 2, cHeight / 2 + 10, 76, sR, sR + (PI + (PI - sR) * 2), baseColor, 8);
        // 画红色圆弧
        drawCanvas(cWidth / 2, cHeight / 2 + 10, 76, sR, endRadian, coverColor, 8);

        // 画红色圆头
        // 红色圆头其实就是一个圆，关键的是找到其圆心，涉及到三角函数知识，自己画个图一看就明了
        var angle = 2 * PI - endRadian; // 转换成逆时针方向的弧度（三角函数中的）
        let xPos = Math.cos(angle) * 76 + cWidth / 2; // 红色圆 圆心的x坐标
        let yPos = -Math.sin(angle) * 76 + cHeight / 2 + 10; // 红色圆 圆心的y坐标
        drawCanvas(xPos, yPos, 2, 0, 2 * PI, coverColor, 2);

        // 总流量
        cxt.fillStyle = textColor;
        cxt.font = '16px PT Sans';
        var fowWidth = cxt.measureText('总流量').width;
        cxt.fillText('总流量', cWidth / 2 - fowWidth / 2, cHeight / 2 - 26);

        // 数字
        cxt.fillStyle = textColor;
        cxt.font = '30px PT Sans';
        let num = flow > 1024 ? (flow / 1024).toFixed(2) : flow
        var textWidth = cxt.measureText(`${num}${flow>1024?'G':'M'}`).width;
        cxt.fillText(`${num}${flow>1024?'G':'M'}`, cWidth / 2 - textWidth / 2, cHeight / 2 + 20);
        text++;

        // 剩余流量
        cxt.fillStyle = textColor;
        cxt.font = '16px PT Sans';
        var dayWidth = cxt.measureText(`剩余${days}天`).width;
        cxt.fillText(`剩余${days}天`, cWidth / 2 - dayWidth / 2, cHeight / 1.1);

        if (endRadian.toFixed(2) < finalRadian.toFixed(2)) {
            window.requestAnimationFrame(paint);
        }
    }

    function drawCanvas(x, y, r, sRadian, eRadian, color, lineWidth) {
        cxt.beginPath();
        cxt.lineCap = "round";
        cxt.strokeStyle = color;
        cxt.lineWidth = lineWidth;
        cxt.arc(x, y, r, sRadian, eRadian, false);
        cxt.stroke();
    }
}

export function parseQrCode(res){
    if(!res) return '';
    let variable = 'd'
    var query = res.substr(res.indexOf('?')).substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){
            let val = pair[1]
            if(val.indexOf('#/') < -1){
                val = val.substring(0,val.length - 2)
            }
            return val;
        }
    }
    return res;
}
/**
 * 重定向页面，添加参数
 * @param routerObj
 * @param obj
 */
 export function replaceRouter (routerObj, obj) {
    const queryMsg = JSON.parse(JSON.stringify(routerObj.query));
    router.replace({
      name: routerObj.name,
      query: Object.assign(queryMsg, obj),
    });
};

/**
 * 查询实名接口
 * @param {*} deviceNum sim / iccid 
 * @param {*} isComponent  是否为组件 默认为false
 * @returns 
 */
export function heandleCheckRealName (deviceNum,isComponent=false) {
    return new Promise((resolve, reject) => {
        this.$http.get(`/equipment/getCardRealNameInfo?card=${deviceNum}`).then(({data}) => {
        if(data.code==301){
            return location.replace(data.msg)
        }
        if(data.code==302){
            sessionStorage.setItem('realNameDevice',deviceNum)
            if(isComponent){
                resolve('huideRealName')
            }else {
                router.push({name: 'huideRealName',params:data.data})
            }
            return;
        }
        if(data.code==303 || data.code==304){
            const { cardIccid, realNameUrl } = data.cardRealName
            return location.replace(realNameUrl)
        }
        if(data.code == 305){ // 匠岩设备
            if(!data.data.isRealName){
            return location.replace(data.data.realNameUrl)
            }
            sessionStorage.setItem('realNameDevice',deviceNum)
            router.replace({
            name:'realName-success',
            query:{
                deviceNum: deviceNum
            }
            })
            return;
        }
        if(data.code==0){
            sessionStorage.setItem('realNameDevice',deviceNum)
            if(data.hasOwnProperty('cardRealInfo')&&data.cardRealInfo.status==1){
            return router.push({
                name:'realName-wait'
            })
            }
            if(data.hasOwnProperty('cardRealInfo')&&data.cardRealInfo.status==2){
            return router.replace({
                name:'realName-success',
                query:{
                deviceNum: deviceNum
                }
            })
            }
            router.push({
            name:'realName-error',
            query:{
                err:data.cardRealInfo.errorMessage
            }
            })
            return
        }
        if(data.code!=0&&data.msg=='查无实名信息！'){
            sessionStorage.setItem('realNameDevice',deviceNum)
            if(isComponent){
                resolve('realNameIdcar')
            }else {
                router.push({name:'realName-idcard'})
            }
            return;
        }else{
            this.$toast(data.msg)
        }
        })
    });
}


/**
 * 返回openID 
 * @param {*} params 
 */
export function getPayOpenId (params,type = 0){
    return new Promise((resolve, reject) => {
        this.$http.post(`/pay/getOpenId`, params)
          .then(({ data }) => {
            if (data.code !== 0) {
              console.log(data);
              resolve('');
            }
            // 存储支付openId
            if(type == 1){
                sessionStorage.setItem("balanceOpenId", data.openId);
            }else {
                sessionStorage.setItem("payOpenId", data.openId);
            }
            console.log("Login", data);
            resolve(data.openId);
          })
          .catch(err => {
            console.log(err);
            resolve('');
          });

    })
}

// 获取最低充值余额
export function miniAmount(){
    return new Promise((resolve, reject) => {
      this.$http.get('/pay/getTopUpMinimumAmount')
      .then(({ data }) => {
        if(data.code == 0){
            resolve(data.data.amount)
        }else {
            resolve(0)
        }
      })
      .catch(err=>{
        console.log(err)
        reject(0)
      })
    });
  }

/**
 * 校验当前弹框标识
 * @param {*} token 
 * @param {*} iccid 
 * @param {*} type 
 * @returns 
 */
export function handleTokenIccid(token,iccid,type){
    let isToken = localStorage.getItem(token+'-'+iccid+'-'+type) || ''
    return Number(isToken) || 0;
}

export function setTokenIccid(token,iccid,type,num){
    localStorage.setItem(token+'-'+iccid+'-'+type,num);
}

/**
 * 弹窗计数
 * @param {*} type 
 * @param {*} countType 
 */
export function marketNumberCount(type,countType){
    this.$http.post('/marketOrder/countNum',{type,countType},{noLoading: true})
    .then(({ data }) => {
        if(data.code == 0){
            console.log('计数成功')
            return;
        }
        console.error(data.msg)
    })
}

/**
 * 处理弹窗是否显示
 * @param {*} show 
 * @param {*} array 
 * @param {*} type 
 * @returns 
 */
export function handleDialogStatus(show,array,type){
    if(!show) return false;
    let obj = array.find(v=> v.type == type)
    if(obj){
      return obj.status == 1 ? true : false;
    }
    return false;
  }

export const handleJson = (type,params)=>{
    return type == 1? JSON.stringify(params) : JSON.parse(params);
}

// 设备余额赠款说明
export const blanceQuestion = ()=> {
    let msg = `1.赠款余额只能用于订购套餐，抵扣订单金额的30%，实际抵扣金额以订购支付页面展示为准。\n 2.赠款余额属于平台赠予金额，不支持退款`
    Dialog.alert({
      confirmButtonColor: '#4367fd',
      message: msg,
    }).then(() => {
      
    })
}
// 客服跳转方法
export const keFuJumpUrl = (obj) => {
    let url =  'https://work.weixin.qq.com/kfid/kfc635cdd1f33210736'
    if (obj.showCustomerService > 1) {
        url = obj.customerServiceUrl
    }
    if (obj.showCustomerService == 3) {
        router.push({name: 'customerService'})
        return;
    }
    if (url.includes('service-landing')) {
        return router.push({name: 'service-landing'})
    }
    if (url.includes('service-landing-1')) {
        return router.push({name: 'service-landing-1'})
    }
    location.href = url
}


// WEBPACK FOOTER //
// ./src/utils/filter.js